import Typography from '@cobliteam/colib-ui/Typography';

interface SummaryRowProps {
  label: string;
  value: string;
  /** Renders the bottom border. Disabled on the last row by the caller. */
  withDivider?: boolean;
}

/**
 * Single label/value row in the confirm-step summary card. The list is intentionally read-only;
 * editing happens on the alerts page via the "Editar alerta" link.
 */
const SummaryRow = ({ label, value, withDivider = true }: SummaryRowProps) => (
  <div className={`flex items-center gap-3 px-4 py-3 ${withDivider ? 'border-border border-b' : ''}`}>
    <Typography variant='caption' className='shrink-0 gap-1 break-words text-muted-foreground'>
      {label}
    </Typography>
    <Typography variant='label' className='gap-1 break-words text-right text-foreground'>
      {value}
    </Typography>
  </div>
);

export default SummaryRow;
export type { SummaryRowProps };
